import ResetPassword from "./LoginCode";

export default ResetPassword;
